<template>
  <el-dialog
    :visible="detailDialogVisible"
    title="审核详情"
    @open="openDialog"
    @close="closeDialog"
  >
    <div class="form-wrap">
      <el-form label-width="200px" :model="auditDetail">
        <el-form-item label="账号：">
          {{auditDetail.userId}}
        </el-form-item>
        <el-form-item label="部落名称：">
          {{auditDetail.name}}
        </el-form-item>
        <el-form-item label="创建时间：">
          {{auditDetail.createTime | moment}}
        </el-form-item>
        <el-form-item label="部落公告内容：">
          {{auditDetail.notice}}
        </el-form-item>
        <el-form-item label="部落图像：">
          <image-wrapper
            :src="auditDetail.imageUrl" 
            :inline="true"
            width="150px"
            height="150px"
          ></image-wrapper>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button 
        @click="toggleDetailDialogVisible(false)"
      >取消</el-button>
      <el-button 
        type="primary" 
        @click="approveAudit(true)"
      >审核通过</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import ImageWrapper from 'components/image';

export default {
  name: 'AuditDetail',
  props: ['value'],
  components: {
    ImageWrapper
  },
  methods: {
    ...mapActions('tribeAudit', ['detail', 'approve']),
    ...mapMutations('tribeAudit', ['toggleDetailDialogVisible']),
    openDialog() {
      this.detail(this.value);
    },
    closeDialog() {
      this.toggleDetailDialogVisible(false);
    },
    approveAudit(isPass) {
      const action = isPass
        ? this.$confirm('确认执行此操作吗？', '提示', {
            type: 'warning'
          })
        : this.$prompt('请输入审核不通过原因', '提示', {
            inputValidator: value => {
              return !value || !value.trim() ? '请输入不通过原因' : true;
            }
          });

      action
        .then(({ value }) => {
          this.approve({
            id: this.value.id
          }).then(() => {
            this.$message({
              type: 'success',
              message: '操作成功！'
            });
            this.toggleDetailDialogVisible(false);
            this.$emit('onUpdate');
          });
        })
        .catch(() => {});
    }
  },
  computed: {
    ...mapState('tribeAudit', ['detailDialogVisible', 'auditDetail'])
  }
};
</script>

<style lang="less" scoped>
@import '~styles/variables.less';

.reason-input {
  width: 100%;
  /deep/ .el-textarea__inner {
    border-color: @color-danger;
    background-color: lighten(@color-danger, 25%);
    resize: none;
    color: #333;
  }
}
.form-wrap {
  word-break: break-all;
}
</style>
